// Copyright 2015 Alexander Krjukov. All rights reserved.

/**
 * @fileoverview Description of file, its uses and dependencies.
 * @author Alexander Krjukov (thatthissideup@gmail.com)
 */
'use strict';

(function(global) {

var dc = global['dc'] = global['dc'] || {};

/**
 * @constructor
 */
dc.BinaryOptionWidget = function() {
	/**
	 * @type {number}
	 * @private
	 */
	this.intervalId_ = -1;
	/**
	 * @type {boolean}
	 * @private
	 */
	this.isLoaded_ = false;
	/**
	 * @type {dc.drawing.Segment}
	 * @private
	 */
	this.priceLevel_ = new dc.drawing.Segment([{}, {}]);
	this.priceLevel_.setPickable(false);
	this.priceLevel_.setStrokeWidth(2);
	this.priceLevel_.setColor("#000");
	/**
	 * @type {dc.drawing.Segment}
	 * @private
	 */
	this.priceText_ = new dc.drawing.Text("", [{}]);
	this.priceText_.setRequiresConfiguration(false);
	this.priceText_.setPickable(false);
	this.priceText_.setFont(14);
	this.priceText_.setColor("#000");
};


/**
 * @enum {string}
 */
dc.BinaryOptionWidget.Direction = {
	PUT: "PUT",
	CALL: "CALL"
};


/**
 * @param {Element=} opt_root
 * @return {!dc.Chart}
 */
dc.BinaryOptionWidget.prototype.render = function(opt_root) {
	var root = opt_root || document.body.appendChild(document.createElement('div'));

	var loadingUnderlay = root.appendChild(document.createElement('div'));
	loadingUnderlay.className = 'loadingScreen';

	var chartContainer = root.appendChild(document.createElement('div'));
	chartContainer.className = 'chartContainer';
	
	this.ui_ = new dc.ChartUI(window.location.search.replace(/^\?/, ''));
	this.ui_.appendChartOptions({
		dataType: dc.DataType.TICK,
		transportType: dc.TransportType.FREESERV,
		//dataFeedUpdateFrequency: 100,
		liveEmulation: true,
		autoShift: true,
		timeline: false,
		period: dc.Period.TICK,
		theme: dc.Theme.Predefined.Pastelle
	});
	this.ui_.showOnlineNewsButton(false);
	this.ui_.showUI(false);
	this.ui_.showDetachButton(false);
	this.ui_.instrumentUri('//freeserv.dukascopy.com/2.0/?path=common/instruments');
	this.ui_.timestampUri('//freeserv.dukascopy.com/2.0/?path=common/timestamp');
	this.ui_.render(root);
	
	this.chart_ = this.ui_.getChart();

	this.chart_.setIncludeDrawingsInScale(true);

	return this.chart_;
};


/**
 * @param {function()=} opt_onInit
 */
dc.BinaryOptionWidget.prototype.init = function(opt_onInit) {
	if (opt_onInit) {
		this.chart_.addEventListener('loaded', opt_onInit);
	}
	//this.chart_.init();
	this.ui_.init();
};


/**
 * @param {BinaryOptionWidget} direction
 * @param {function(boolean)} callback
 * @param {number=} opt_duration
 * @return {number}
 */
dc.BinaryOptionWidget.prototype.startOption = function(direction, callback, offset, opt_duration) {
	var duration = opt_duration || 60 * 1000;
	
	
	//var start = Date.now() - offset;
	var start = this.chart_.getDataProvider().peek().getTime();
	var end = start + opt_duration;

	var data = this.chart_.getDataProvider().peek();
	var strike = (direction == dc.BinaryOptionWidget.Direction.PUT) ?
		data.getAsk() :
		data.getBid();

	this.priceLevel_.setTime(0, start);
	this.priceLevel_.setValue(0, strike);

	this.priceLevel_.setTime(1, end);
	this.priceLevel_.setValue(1, strike);

	this.priceText_.setTime(0, start);
	this.priceText_.setValue(0, strike);
	this.priceText_.setText(strike.toFixed(5));

	this.chart_.getChartObjectMonitor().addObject(this.priceText_);
	this.chart_.getChartObjectMonitor().addObject(this.priceLevel_);

	setTimeout(checkOption, duration, this);
	function checkOption(self) {
		var data = self.chart_.getDataProvider().peek();
		var price = (direction == dc.BinaryOptionWidget.Direction.PUT) ?
			data.getBid() :
			data.getAsk();

		callback((direction == dc.BinaryOptionWidget.Direction.PUT) ?
			(price < strike) :
			(price > strike));
	}
};

/**
 * @param {number=} opt_intervalId
 */
dc.BinaryOptionWidget.prototype.stopOption = function(opt_intervalId) {
	clearTimeout(opt_intervalId || this.intervalId_);
	this.chart_.getChartObjectMonitor().deleteObject(this.priceText_);
	this.chart_.getChartObjectMonitor().deleteObject(this.priceLevel_);
};

})(this);